'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FadeOut = _react2['default'].createClass({
    displayName: 'FadeOut',


    propTypes: {
        key: _react2['default'].PropTypes.string //NOTE: If another React component is leveraging this component, include a unique key for each generated message. See MultiSelect for more info.
    },

    getInitialState: function getInitialState() {
        return { isMounted: true };
    },
    componentDidMount: function componentDidMount() {
        this.mountAndFadeOut();
    },
    componentWillUnmount: function componentWillUnmount() {
        _reactDom2['default'].unmountComponentAtNode(_reactDom2['default'].findDOMNode(this));
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (this.props.key !== nextProps.key) {
            this.mountAndFadeOut();
        }
    },
    mountAndFadeOut: function mountAndFadeOut() {
        _reactDom2['default'].render(_react2['default'].createElement(
            'span',
            null,
            this.props.children
        ), this.refs.contents);
        this.fadeOut();
    },
    fadeOut: function fadeOut() {
        $(this.refs.contents).fadeOut(5000, function () {
            if (this.isMounted()) {
                _reactDom2['default'].unmountComponentAtNode(_reactDom2['default'].findDOMNode(this));
            }
        }.bind(this));
    },
    render: function render() {
        return _react2['default'].createElement('span', { style: { display: 'inline-block' }, ref: 'contents' });
    }
});
module.exports = FadeOut;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/fade-out.jsx
 ** module id = 1207
 ** module chunks = 0
 **/